import { createAppAsyncThunk } from 'src/store/utils/thunks';
import { wsMmSend, createMmWsAction } from '@skynet/data-ws-mm';

import { BotCommands } from './types';
import type { CreateSessionPayload, JsonWebMessageRequest, TradingMessageSession } from './types';

export const createSessionWs = createMmWsAction<TradingMessageSession, TradingMessageSession>(
  'bots/createSessionWs',
  (data) => ({
    command: BotCommands.CreateSession,
    ...data,
  }),
);

export const createSession = createAppAsyncThunk(
  'bots/createSession',
  (data: CreateSessionPayload, thunkApi) => {
    const session = String(Math.floor(Math.random() * (99999999999 - 10000000000) + 10000000000));
    const payload = {
      ID: data.groupId,
      session,
    };
    thunkApi.dispatch(createSessionWs(payload));
    return payload;
  },
);

export const sendMessageWs = createAppAsyncThunk(
  'bots/sendMessage',
  (data: Omit<JsonWebMessageRequest, 'command'>, thunkApi) => {
    return thunkApi.dispatch(
      wsMmSend({
        command: BotCommands.WebMessage,
        ...data,
      }),
    );
  },
);
